import {defineStore, storeToRefs} from "pinia";
import {computed, ref} from "vue";
import {useScopeQuery} from "@/core/store/scopeQuery";
import {useCatalogStore} from "@/modules/shop/store/catalog";

const STORE_NAME = 'shop-catalog-fav'

export const useCatalogFavStore = defineStore(STORE_NAME, () => {

    const {registerScopeQuery} = useScopeQuery()
    const catalogStore = useCatalogStore()

    const favoriteProductIds = ref<Record<string, number>>({})

    const {productsModelsById} = storeToRefs(catalogStore)

    const favToggle = async (productId: number) => {
        if (favoriteProductIds.value[productId]) {
            delete favoriteProductIds.value[productId]
        } else {
            favoriteProductIds.value[productId] = productId
        }
    }

    const favorites = computed(() => {
        return Object.values(favoriteProductIds.value).filter(id => !!productsModelsById.value[id]).map(id => productsModelsById.value[id]!)
    })

    const isInFavorites = (productId: number) => {
        return !!favoriteProductIds.value[productId]
    }

    const favoritesCount = computed(() => Object.keys(favoriteProductIds.value).length)

    const clearFavorites = () => {
        favoriteProductIds.value = {}
    }

    return {
        favoriteProductIds,
        favorites,
        favToggle,
        isInFavorites,
        favoritesCount,
        clearFavorites
    }
}, {
    persist: {
        pick: [
            'favoriteProductIds'
        ],
    }
})

